import React, { Component } from "react";

export class ValidationSummary extends Component {
  constructor(props) {
    super(props);
    this.closeClicked = 0;
    this.state = { showErrorDiv: true };
    this.closeDiv = this.closeDiv.bind(this);
  }

  closeDiv() {
    this.setState({ showErrorDiv: false });
    this.closeClicked = 1;
  }

  render() {
    if (this.closeClicked == 2) {
      this.setState({ showErrorDiv: true });
      this.closeClicked = 0;
    } else if (this.closeClicked == 1) {
      this.closeClicked = 2;
    }

    if (this.props.errorMsg.length == 0 && this.state.showErrorDiv) {
      this.setState({ showErrorDiv: false });
    } else if (
      this.props.errorMsg.length > 0 &&
      !this.state.showErrorDiv &&
      this.closeClicked != 2
    ) {
      this.setState({ showErrorDiv: true });
    }
    // console.log(this.state.showErrorDiv);
    // console.log(this.props.errorMsg);
    return (
      <div id="form-alert" className="form-validaton-msgs">
        {this.state.showErrorDiv ? (
          <ul>
            {" "}
            <div id="form-error-msgs">
              <button type="button" className="close">
                <span aria-hidden="true" onClick={this.closeDiv}>
                  &times;
                </span>
                <span className="sr-only">Close</span>
              </button>

              {this.props.errorMsg.map((info, index) => (
                <li key={index}>
                  {info} <br />
                </li>
              ))}
            </div>
          </ul>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/utility/ValidationSummary.js